import React from 'react';
import {connectWithCore} from 'framework/hocs';
import {Segment, Pagination, Message, Loader} from 'semantic-ui-react';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {Link} from 'react-router-dom';
import REST from 'go/requests/rest';
import _ from 'lodash';

export class ManageGroupsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      groups: [],
      pageNum: 0,
      error: false,
      loading: false,
      numGroups: 0,
      errorMessage: '',
      totalPages: 0,
    };
  }

  getGroups = () => {
    const {token, sessionId} = this.props;
    const pageSize = 20;
    this.setState({
      loading: true,
    });
    return REST.panelReviewV2
      .getGroupsBySession(token, sessionId, this.state.pageNum, pageSize)
      .then(REST.handler.handleResponse)
      .then((res) => {
        if (_.size(_.get(res, 'content')) === 0) {
          this.setState({
            error: true,
            loading: false,
          });
        } else {
          this.setState({
            groups: [...res.content],
            error: false,
            loading: false,
            numGroups: res.totalElements,
            totalPages: res.totalPages,
          });
        }
      })
      .catch((err) => {
        this.setState({
          error: true,
          loading: false,
          errorMessage: 'There was an error retrieving groups. Please refresh the page.',
        });
      });
  };

  handlePageChange = async (e, {activePage}) => {
    await this.setState({pageNum: activePage - 1});
    this.getGroups();
  };

  componentDidMount() {
    this.getGroups();
  }

  renderTable(groups) {
    if (groups && groups.length) {
      return _.map(groups, (group) => {
        return (
          <FemaGoTable.Row>
            <FemaGoTable.TextCell>
              <Link
                to={`/panelReview/admin/sessions/${group.sessionId}/groups/${group.groupId}`}
              >
                {group.name}
              </Link>
            </FemaGoTable.TextCell>
            <FemaGoTable.TextCell>{group.category}</FemaGoTable.TextCell>
            <FemaGoTable.TextCell>
              {group.suspended ? 'Inactive' : 'Active'}
            </FemaGoTable.TextCell>
          </FemaGoTable.Row>
        );
      });
    } else {
      return (
        <FemaGoTable.Row>
          <FemaGoTable.TextCell> </FemaGoTable.TextCell>
        </FemaGoTable.Row>
      );
    }
  }

  render() {
    const {groups, error, pageNum, totalPages, loading} = this.state;
    const {aliases} = this.props;
    const category = _.get(_.find(aliases, {value: 'category'}), 'label');

    if (loading)
      return (
        <Loader inline="centered" active>
          Loading...
        </Loader>
      );
    return (
      <React.Fragment>
        {error ? (
          <p>There are currently no groups to display.</p>
        ) : (
          <React.Fragment>
            <Segment>
              <FemaGoTable summary="Manage groups table">
                <FemaGoTable.Header>
                  <FemaGoTable.Row>
                    <FemaGoTable.HeaderCell>Group name</FemaGoTable.HeaderCell>
                    <FemaGoTable.HeaderCell>{category}</FemaGoTable.HeaderCell>
                    <FemaGoTable.HeaderCell>Status</FemaGoTable.HeaderCell>
                  </FemaGoTable.Row>
                </FemaGoTable.Header>
                {!this.state.error && (
                  <FemaGoTable.Body>{this.renderTable(groups)}</FemaGoTable.Body>
                )}
              </FemaGoTable>
            </Segment>
            <Pagination
              activePage={pageNum + 1}
              firstItem={null}
              lastItem={null}
              siblingRange={1}
              boundaryRange={1}
              ellipsisItem={null}
              totalPages={totalPages}
              onPageChange={this.handlePageChange}
            ></Pagination>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default connectWithCore(ManageGroupsPage);
